<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">上榜隐身</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="main">
      <div class="dtl">
          <p>功能介绍：上榜隐身分豪气榜隐身和魅力榜隐身。</p>
          <p>设置了豪气榜隐身，在豪气榜上将不会显示你的头像和昵称，并且其他用户无法直接点击进去和你聊天，防止受到骚扰。</p>
          <p>设置了魅力榜隐身，在魅力榜上将不会显示你的头像和昵称，并且其他用户无法直接点击进去和你聊天，防止受到骚扰。</p>
      </div>

       <div class="menu-block">
          <div class="menu-item ub ub-pc">
            <span class="ub-ae ub-f1 ">豪气榜隐身</span>
            <label class="switch">
              <input type="checkbox" v-model="coin_check" @change="change_coin()" />
              <div class="slider round"></div>
            </label>
          </div>

          <div class="menu-line"></div>

          <div class="menu-item ub ub-pc">
            <span class="ub-ae ub-f1 ">魅力榜隐身</span>
            <label class="switch">
              <input type="checkbox" v-model="score_check" @change="change_score()"/>
              <div class="slider round"></div>
            </label>
          </div>

        </div>


    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      user: {
        score_total: 0,
        coin_total: 0,
        show_coin: 0,
        show_score: 0,
        vip_level: 0,
        set_bord_coin:0,
        set_bord_score:0
      },
       coin_check:false, //豪气榜
       score_check:false,
       theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_reload_userinfo", "act_get_userinfo"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_vip() {
      this.$router.push({ name: "vip_center" });
    },
    init_page() {
      var uid = this.$store.state.uid;
      var self = this;

      self.get({
        url: "/App/GetBordData/?uid=" + uid,
        success: function (data) {
        //console.log(JSON.stringify(data));
         self.user.set_bord_coin=data.set_bord_coin;
         self.user.set_bord_score=data.set_bord_score;
         self.coin_check = self.user.set_bord_coin == 1 ? true : false;
         self.score_check = self.user.set_bord_score == 1 ? true : false;
        },
      });


    },
    change_coin(){
        this.user.set_bord_coin = this.coin_check ? 1 : 0;
        //console.log(this.user.set_bord_coin)
        var send_data = { "set_bord_coin": this.user.set_bord_coin};
        this.dosave(send_data);
    },
    change_score(){

        this.user.set_bord_score = this.score_check ? 1 : 0;
        //console.log(this.user.set_bord_score)
        var send_data = { "set_bord_score": this.user.set_bord_score};
        this.dosave(send_data);
    },

    dosave(send_data){
        var self = this;
        var uid = this.$store.state.uid;
        var data = {
          url: "/App/User_ModifyBaseInfo",
          data: {
            uid: uid,
            data: JSON.stringify(send_data),
          },
          success: function (data_serve) {
            if (data_serve.state == "1") {
               //设置成功
               self.$toast.top("设置成功");
            }
          },
        };
        self.post(data);
    }

  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #EFEFEF;
}
.main {
  margin-top: 1rem;
  padding: 0 0.8rem;
  .dtl {
    border-radius: 0.5rem;
    font-size: 0.75rem;
    line-height: 1.65rem;
    color: #333;
  }
  .menu-block {
    padding: 1rem 0.8rem;
    background-color: #FDFDFD;
    border-radius: 0.5rem;
    .menu-item {
      height: 3rem;
      span {
        font-size: 0.9rem;
        font-weight: bold;
        color: #333;
      }
      .switch {
        position: relative;
        display: inline-block;
        width: 3.2rem;
        height: 1.8rem;
        input {
          display: none;
          outline: 0;
        }
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 3.5rem;
        height: 1.8rem;
        background-color: #EFEFEF;
        transition: 0.1s;
        border: 2px solid #EFEFEF;
        user-select: none;
        border-radius: 1.1em;
        outline-style: none;
        border: 1px solid #EFEFEF;
        text-shadow: none;
        -webkit-appearance: none;
        -webkit-user-select: text;
        -webkit-tap-highlight-color:rgba(0,0,0,0);

      }


      .slider:before {
        position: absolute;
        content: "";
        height: 1.8rem;
        width: 1.8rem;
        background-color: white;
        transition: 0.1s;
        box-shadow: 0px 0.1px 2px #EEEEEE;
        border-radius: 50%;
      }
      input:checked + .slider {
        background-color: #45db5e;
      }
      input:checked + .slider:before {
        transform: translateX(1.7rem);
      }
    }
  }
}

.menu-line {
  border-top: 1px solid #EFEFEF;
  margin: 1rem 0;
}

.container-dark {
  background-color: #2f2e33;
  .main {
    .dtl {
      color: #888;
    }
    .menu-block {
      background-color: #2c2b30;
      .menu-item {
        span {
          color: #fdfdfd;
        }
      }
    }
    .menu-line {
      border-top: 1px solid #404040;
    }
  }
}
</style>
